import { OrderTypeEnum } from '@@fire-b2b/types/order/OrderTypeEnum'
import { normalizeRouteName } from '@fire-b2b/utils/helpers'

const WISHLIST_ROUTES = new Set(['wishlist', 'wishlist-detail'])

export default defineNuxtRouteMiddleware((to) => {
  const routeName = normalizeRouteName(to.name)

  if (!routeName || !WISHLIST_ROUTES.has(routeName)) {
    return
  }

  if (to.params.orderType === OrderTypeEnum.REORDER) {
    return
  }

  throw routeErrorNotFound()
})
